import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { FormControl, InputLabel, MenuItem, Select, Typography } from '@mui/material';

import { setIsDirty } from 'features/common/formSlice';
import {
    selectConfigValuesSelectedAssetId,
    selectConfigValuesSelectedClientId,
    setSelectedAssetId,
} from 'features/configValues/configValuesSlice';
import { getClientAssetsPicklist, selectClientAssetsPicklist } from 'features/picklists/pickListsSlice';
import { sortByCaseInsensitiveText } from 'GeminiViewerComponent/helpers/lodashUtils';

export const AssetSelect = () => {
    const assets = useSelector(selectClientAssetsPicklist);
    const selectedClientId = useSelector(selectConfigValuesSelectedClientId);
    const selectedAssetId = useSelector(selectConfigValuesSelectedAssetId);
    const dispatch = useDispatch();

    useEffect(() => {
        if (selectedClientId !== 0) {
            dispatch(getClientAssetsPicklist(selectedClientId));
        }
    }, [selectedClientId, dispatch]);

    const assetsWithDefault = [
        { asset_id: 0, display_name: '==GLOBAL==' },
        ...[...assets].sort(sortByCaseInsensitiveText('display_name')),
    ];

    return (
        <FormControl size="small">
            <InputLabel id="asset-select-label">Asset Override</InputLabel>
            <Select
                size="small"
                labelId="asset-select-label"
                label="Asset Override"
                id="asset-select"
                style={{ minWidth: '300px' }}
                value={selectedAssetId}
                onChange={async (e) => {
                    await dispatch(
                        setSelectedAssetId({
                            assetId: e.target.value,
                        })
                    );
                    await dispatch(setIsDirty(false));
                }}
                MenuProps={{
                    PaperProps: {
                        style: {
                            maxHeight: 48 * 10 + 8,
                            width: 250,
                        },
                    },
                }}
            >
                {assetsWithDefault.map((asset) => (
                    <MenuItem
                        key={asset.asset_id}
                        value={asset.asset_id}
                        style={{ maxWidth: '300px' }}
                        title={asset.display_name}
                    >
                        <Typography
                            style={{
                                width: '100%',
                                textOverflow: 'ellipsis',
                                overflow: 'hidden',
                                whiteSpace: 'nowrap',
                            }}
                        >
                            {asset.display_name}
                        </Typography>
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};
